module.exports = __webpack_public_path__ + "img/13.4ec7929a.png";